export default class Budget {
	students: any;
	teachers: any;
	start_date: any;
	end_date: any;
	who: any;
	responsible_name_surname: any;
	center: any;
	responsible_email: any;
	responsible_phone: any;
	others: any;
	terms: boolean;
	privacity: any;
	budget_id: any;
	state_id: any;
	state_name: any;
	country_id: any;
	country_name: any;
	customer_id: any;
	ages_id: any;
	travel_id: any;
	city_id: any;
	city_name: any;
	travel_name: any;
	travel_duration_min: any;
	travel_duration_max: any;
	travel_season_end: any;
	customer_budget_id: any;
	accommodation: any;
	accommodation_name: any;
	accommodation_price: any;
	accommodation_extras: any;
	students_price: any;
	extra_service_price: any;
	amount: any;
	transport: any;
	transport_name: any;
	transport_price: any;
	transport_extras: any;
	extra_service: any;
	extra_service_name: any;
	activity: any;
	free_teacher_by_students: any;
	supplement: any;
	total_amount: any;
	days: number

	constructor() {
		this.students = 15;
		this.teachers = 2;
		this.start_date = null;
		this.end_date = null;
		this.who = null;
		this.responsible_name_surname = null;
		this.center = null;
		this.responsible_email = null;
		this.responsible_phone = null;
		this.others = null;
		this.terms = false;
		this.privacity = false;
		this.budget_id = null;
		this.state_id = null;
		this.state_name = null;
		this.country_id = null;
		this.country_name = null;
		this.customer_id = null;
		this.ages_id = null;
		this.travel_id = null;
		this.city_id = null;
		this.city_name = null;
		this.travel_name = null;
		this.travel_duration_min = null;
		this.travel_duration_max = null;
		this.travel_season_end = null;
		this.customer_budget_id = null;
		this.accommodation = null;
		this.accommodation_name = null;
		this.accommodation_price = null;
		this.accommodation_extras = [];
		this.students_price = null;
		this.extra_service_price = null;
		this.amount = null;
		this.transport = null;
		this.transport_name = null;
		this.transport_price = null;
		this.transport_extras = [];
		this.extra_service = null;
		this.extra_service_name = null;
		this.activity = null;
		this.total_amount = null;
		this.free_teacher_by_students = null;
		this.supplement = null;
		this.days = 0;
	}

	public static copy(model: any) {
		const aux = new Budget();
		aux.students = model.students;
		aux.teachers = model.teachers;
		aux.start_date = model.start_date;
		aux.end_date = model.end_date;
		aux.who = model.who;
		aux.responsible_name_surname = model.responsible_name_surname;
		aux.center = model.center;
		aux.responsible_email = model.responsible_email;
		aux.responsible_phone = model.responsible_phone;
		if (model.terms) {
			aux.terms = model.terms;
		}
		if (model.privacity) {
			aux.privacity = model.privacity;
		}
		aux.others = model.others;
		aux.budget_id = model.budget_id;
		aux.state_id = model.state_id;
		aux.state_name = model.state_name;
		aux.country_id = model.country_id;
		aux.country_name = model.country_name;
		aux.customer_id = model.customer_id;
		aux.ages_id = model.ages_id;
		aux.travel_id = model.travel_id;
		aux.city_id = model.city_id;
		aux.city_name = model.city_name;
		aux.travel_name = model.travel_name;
		aux.travel_duration_min = model.travel_duration_min;
		aux.travel_duration_max = model.travel_duration_max;
		aux.travel_season_end = model.travel_season_end;
		aux.customer_budget_id = model.customer_budget_id;
		aux.accommodation = model.accommodation;
		if(model.accommodation){
			aux.accommodation_name = model.accommodation.name;
			aux.accommodation_price = model.accommodation.price;
			aux.accommodation_extras = model.accommodation.extras;
		}
		aux.students_price = model.students_price;
		aux.extra_service_price = model.extra_service_price;
		aux.amount = model.amount;
		aux.transport = model.transport;
		if(model.transport){
			aux.transport_name = model.transport.name;
			aux.transport_price = model.transport.transport_price;
			aux.transport_extras = model.transport.transport_extras;
		}
		aux.extra_service = model.extra_service;
		if(model.extra_service){
			aux.extra_service_name = model.extra_service.name;
		}
		aux.activity = model.activity;
		aux.total_amount = model.total_amount;
		aux.free_teacher_by_students = model.free_teacher_by_students;
		aux.supplement = model.supplement;
		aux.days = model.days;
		return aux;
	}
}
